export const issueTypeFields = {
	data: {
		node: {
			getArchivedIssuesFilterOptions: {
				projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
				issueTypes: {
					edges: [
						{
							id: 'ari:cloud:jira:28dfbea9-9711-4ee8-8d84-454e910384a9:issue-type/10029',
							issueTypeId: '10029',
							name: 'Task',
							description: 'A small, distinct piece of work.',
							avatar: {
								__typename: 'JiraAvatar',
								small:
									'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=small',
								medium:
									'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=medium',
								large:
									'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557',
							},
							avatarId: '10557',
							hierarchy: {
								level: 0,
								name: 'Story',
							},
						},
						{
							issueTypeId: '10006',
							name: 'Epic',
							avatar: {
								medium:
									'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
							},
						},
						{
							issueTypeId: '10004',
							name: 'Story',
							avatar: {
								medium:
									'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
							},
						},
					],
				},
			},
		},
	},
};
